import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import { NotificationInfo, UserInfo } from "../../../../context";
import SaveDeliveryUnsave from "./SaveDeliveryUnsave";

const AddDeliveryOrders = ({ close, getDeliverySaveList }) => {
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);
  const [productRawList, setProductRawList] = useState({
    data: [],
    ready: false,
  });
  const [deliveryUnsaveRawList, setDeliveryUnsaveList] = useState({
    data: [],
    ready: false,
  });
  const [specProductInfo, setSpecProductInfo] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedConversion, setSelectedConversion] = useState("");
  const [selectedIsNewExpiry, setSelectedIsNewExpiry] = useState("");
  const [selectedDeliveredUnit, setSelectedDeliveredUnit] = useState("");
  const [form] = Form.useForm();
  const [selectedData, setSelectedData] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [inputedDeliveredUnitConversion, setInputedDeliveredUnitConversion] =
    useState(0);
  const [inputedQuantityConversion, setInputedQuantityConversion] = useState(0);

  const columns = [
    {
      title: "Product",
      dataIndex: ["deliveryunsaverawproduct", "product"],
      // sorter: (a, b) =>
      //   a.deliveryunsaverawproduct.product - b.deliveryunsaverawproduct.product,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Expiry Date",
      // dataIndex: ["deliveryunsaverawproduct", "description"],
      dataIndex: "expiry_date",
      // sorter: (a, b) =>
      //   a.deliveryunsaverawproduct.description -
      //   b.deliveryunsaverawproduct.description,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Unit",
      dataIndex: ["deliveryunsaverawproduct", "rawproductsuserunit", "unit"],
      // align: "right",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      align: "right",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const getRawProductList = useCallback(() => {
    var params = { user_id: userData.data.id, is_production: "all" };
    axios
      .get("user/commissary/raw-product-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setProductRawList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getDeliveryUnsaveList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/delivery-unsave-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setDeliveryUnsaveList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const handleFetchProduct = (rawID) => {
    var params = {
      raw_id: rawID,
      user_id: userData.data.id,
    };
    setSpecProductInfo({ data: [], ready: false });
    axios
      .get("user/commissary/spec-product-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setSpecProductInfo({ data, ready: true });

        form.setFieldsValue({
          is_new_expiry: "",
          expiry_date: "",
          conversion: "",
          delivered_unit: "",
          delivered_unit_conversion: "",
          delivered_quantity: "",
        });
        setSelectedConversion("");
        setSelectedDeliveredUnit("");
        setInputedDeliveredUnitConversion(0);
        setInputedQuantityConversion(0);
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    getRawProductList();
    getDeliveryUnsaveList();
  }, [getRawProductList, getDeliveryUnsaveList]);

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteProductInDelivery();
    }, 2000);
  };

  const handleDeleteProductInDelivery = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    setLoadings(true);
    axios
      .post("user/commissary/delete-product-in-delivery", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete product successfully.");
          setTimeout(() => {
            setLoadings(false);
            getDeliveryUnsaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleAddProductToUnsave = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "total_quantity",
      Boolean(parseInt(selectedConversion))
        ? parseInt(inputedQuantityConversion) *
            parseInt(inputedDeliveredUnitConversion)
        : parseInt(inputedQuantityConversion)
    );
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/commissary/new-delivery-product-unsave", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "product-exist") {
          rerunNotif("error", "Product already added!");
          setTimeout(() => {
            form.setFieldsValue({
              is_new_expiry: "",
              expiry_date: "",
              conversion: "",
              delivered_unit: "",
              delivered_unit_conversion: "",
              delivered_quantity: "",
            });
            setLoadings(false);
            setLoading(false);

            setSelectedConversion("");
            setSelectedDeliveredUnit("");
            setInputedDeliveredUnitConversion(0);
            setInputedQuantityConversion(0);
          }, 1000);
        }
        if (data === "success") {
          rerunNotif("success", "Added product successfully.");
          setTimeout(() => {
            // close();
            form.setFieldsValue({
              is_new_expiry: "",
              expiry_date: "",
              conversion: "",
              delivered_unit: "",
              delivered_unit_conversion: "",
              delivered_quantity: "",
            });
            setLoadings(false);
            setLoading(false);
            getDeliveryUnsaveList();

            setSelectedConversion("");
            setSelectedDeliveredUnit("");
            setInputedDeliveredUnitConversion(0);
            setInputedQuantityConversion(0);
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <Button type="primary" icon={<CloseOutlined />} onClick={() => close()}>
          Close
        </Button>
      </div>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={16}>
          <div style={{ border: "1px solid #e5e5e5", borderRadius: 5 }}>
            <div style={{ padding: 10 }}>
              <div style={{ marginBottom: 10 }}>
                <Typography.Title level={4}>
                  Creating For Receiving Orders
                </Typography.Title>
              </div>
              <div style={{ overflowX: "auto" }}>
                <Table
                  {...tableProps}
                  pagination={{
                    position: ["bottomCenter"],
                  }}
                  columns={tableColumns}
                  dataSource={
                    deliveryUnsaveRawList.data.length > 0
                      ? deliveryUnsaveRawList.data
                      : []
                  }
                  scroll={scroll}
                  rowKey={(record) => record.id}
                />
                <div
                  style={{
                    display:
                      deliveryUnsaveRawList.data.length > 0 ? "flex" : "none",
                  }}
                >
                  <div style={{ flexGrow: 1 }} />
                  <div>
                    <Button
                      type="primary"
                      loading={loadings}
                      //   htmlType="submit"
                      //   style={{ width: "100%", borderRadius: "20px" }}
                      onClick={() => setOpenDrawer(true)}
                    >
                      {loadings ? "Loading" : "Create"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <div style={{ border: "1px solid #e5e5e5", borderRadius: 5 }}>
            <div style={{ padding: 10 }}>
              <div style={{ marginBottom: 10 }}>
                <Typography.Title level={4}>
                  Add All Raw Materials Received
                </Typography.Title>
              </div>
              <div>
                <Form
                  form={form}
                  layout="vertical"
                  name="basic"
                  initialValues={{ remember: false }}
                  onFinish={handleAddProductToUnsave}
                  autoComplete="off"
                >
                  <Space
                    direction="vertical"
                    style={{
                      width: "100%",
                      margin: 0,
                    }}
                  >
                    <Form.Item
                      name="product"
                      label="Product"
                      rules={[
                        {
                          required: true,
                          message: "Required",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select product"
                        onChange={(e) => {
                          handleFetchProduct(e);
                          // console.log("EVENT", e);
                        }}
                        size="large"
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {productRawList.data.length > 0 ? (
                          productRawList.data.map((data, index) => (
                            <Select.Option value={data.raw_id} key={index}>
                              {data.product}
                            </Select.Option>
                          ))
                        ) : (
                          <Select.Option value="">
                            No raw product found!
                          </Select.Option>
                        )}
                      </Select>
                    </Form.Item>

                    {specProductInfo.ready && specProductInfo.data && (
                      <>
                        <Form.Item
                          // name="unit"
                          label="Unit"
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Required",
                          //   },
                          // ]}
                        >
                          <Input
                            placeholder="Set unit"
                            size="large"
                            defaultValue={
                              specProductInfo.data[0].rawproductsuserunit.unit
                            }
                            disabled
                          />
                        </Form.Item>

                        <Form.Item
                          name="is_new_expiry"
                          label="New Expiry?"
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          <Select
                            placeholder="-"
                            onChange={(e) => {
                              setSelectedIsNewExpiry(e);
                              form.setFieldsValue({
                                expiry_date: "",
                              });
                            }}
                            size="large"
                            showSearch
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            <Select.Option value={1}>Yes</Select.Option>
                            <Select.Option value={0}>No</Select.Option>
                          </Select>
                        </Form.Item>

                        {selectedIsNewExpiry !== "" && (
                          <Form.Item
                            name="expiry_date"
                            label="Select Expiry"
                            rules={[
                              {
                                required: true,
                                message: "Required",
                              },
                            ]}
                          >
                            {Boolean(parseInt(selectedIsNewExpiry)) ? (
                              <DatePicker
                                format={"MM/DD/YYYY"}
                                size="large"
                                style={{ width: "100%" }}
                              />
                            ) : (
                              <Select placeholder="-" size="large" showSearch>
                                {specProductInfo.data[0].productdelivery
                                  .length > 0 ? (
                                  specProductInfo.data[0].productdelivery.map(
                                    (data, index) => (
                                      <Select.Option
                                        value={data.expiry_date}
                                        key={index}
                                      >
                                        {data.expiry_date}
                                      </Select.Option>
                                    )
                                  )
                                ) : (
                                  <Select.Option value="">
                                    No expiry date
                                  </Select.Option>
                                )}
                              </Select>
                            )}
                          </Form.Item>
                        )}

                        <Form.Item
                          name="conversion"
                          label="Need Conversion?"
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          <Select
                            placeholder="-"
                            onChange={(e) => {
                              setSelectedConversion(e);
                            }}
                            size="large"
                            showSearch
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            <Select.Option value={1}>Yes</Select.Option>
                            <Select.Option value={0}>No</Select.Option>
                          </Select>
                        </Form.Item>

                        {Boolean(parseInt(selectedConversion)) && (
                          <>
                            <Form.Item
                              name="delivered_unit"
                              label="Received Unit?"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Set received unit"
                                size="large"
                                value={selectedDeliveredUnit}
                                onChange={(e) =>
                                  setSelectedDeliveredUnit(e.target.value)
                                }
                              />
                            </Form.Item>

                            {selectedDeliveredUnit !== "" && (
                              <Form.Item
                                name="delivered_unit_conversion"
                                label={`How many ${specProductInfo.data[0].rawproductsuserunit.unit} in 1 ${selectedDeliveredUnit}`}
                                rules={[
                                  {
                                    required: true,
                                    message: "Required",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder={`Set ${specProductInfo.data[0].rawproductsuserunit.unit} in 1 ${selectedDeliveredUnit}`}
                                  size="large"
                                  value={inputedDeliveredUnitConversion}
                                  onChange={(e) => {
                                    if (e.target.value.length > 0) {
                                      setInputedDeliveredUnitConversion(
                                        e.target.value
                                      );
                                    } else {
                                      setInputedDeliveredUnitConversion(0);
                                    }
                                  }}
                                />
                              </Form.Item>
                            )}
                          </>
                        )}

                        <Form.Item
                          name="delivered_quantity"
                          label="Received Quantity"
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          {/* <Input
                            placeholder="Set received quantity"
                            size="large"
                            value={inputedQuantityConversion}
                            onChange={(e) =>
                              setInputedQuantityConversion(e.target.value)
                            }
                            style={{ width: "100%" }}
                          /> */}

                          <InputNumber
                            min={1}
                            max={999999999999}
                            // initialvalues={0}
                            value={inputedQuantityConversion}
                            size="large"
                            style={{ width: "100%" }}
                            step="1"
                            onChange={(value) => {
                              if (value === null) {
                                setInputedQuantityConversion(0);
                              } else {
                                setInputedQuantityConversion(value);
                              }

                              // console.log("value", value);
                              // var newValue = value.toString();
                              // console.log("newValue", newValue);
                              // if (value.length.toString() > 0) {
                              //   setInputedQuantityConversion(value);
                              // } else {
                              //   setInputedQuantityConversion(0);
                              // }
                            }}
                          />
                        </Form.Item>

                        <Typography style={{ fontWeight: "bold" }}>
                          Total Quantity :{" "}
                          {Boolean(parseInt(selectedConversion))
                            ? parseInt(inputedQuantityConversion) *
                              parseInt(inputedDeliveredUnitConversion)
                            : parseInt(inputedQuantityConversion)}{" "}
                          {specProductInfo.data[0].rawproductsuserunit.unit}
                        </Typography>
                      </>
                    )}
                  </Space>

                  <Form.Item style={{ marginTop: "20px" }}>
                    <Button
                      type="primary"
                      loading={loadings}
                      htmlType="submit"
                      style={{ width: "100%", borderRadius: "20px" }}
                      disabled={
                        Boolean(parseInt(selectedConversion))
                          ? parseInt(inputedQuantityConversion) *
                              parseInt(inputedDeliveredUnitConversion) ===
                            0
                          : parseInt(inputedQuantityConversion) === 0
                      }
                    >
                      {loadings ? "Loading" : "Add"}
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {openDrawer && (
        <SaveDeliveryUnsave
          closeOriginalTab={() => close()}
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getDeliveryUnsaveList={() => getDeliveryUnsaveList()}
          getDeliverySaveList={() => getDeliverySaveList()}
        />
      )}

      <Modal
        title="Are you sure to delete this product?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
      />
    </>
  );
};

export default AddDeliveryOrders;
